import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  confirmationDialog: {
    position: "relative",
    "& .MuiDialogTitle-root": {
      maxHeight: 56
    },
    "& .MuiPaper-root": {
      maxWidth: 300
    },
    "& .MuiDialogContent-root, & .MuiDialogTitle-root": {
      paddingLeft: 20,
      paddingRight: 20
    },
    "& .MuiDialogContent-root": {
      paddingTop: 0,
      paddingBottom: 16
    },
    "& .MuiDialogActions-root": {
      paddingTop: 0,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 10
    }
  },
  dialogTitleTypography: {
    fontSize: 20,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontWeight: "bold",
    lineHeight: "normal",
    color: theme.palette.text.primary
  },
  dialogContentText: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    lineHeight: "19px"
  },
  button: {
    fontSize: 16,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  save: {
    color: theme.palette.secondary.dark
  },
  discard: {
    color: theme.palette.error.main
  },
  confirm: {
    color: theme.palette.secondary.dark
  },
  cancel: {
    color: theme.palette.text.secondary
  },
  decisions: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "end",
    gap: 20
  },
  unsavedChangesDialogContent: {
    color: theme.palette.text.secondary
  }
}));
